import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fichas',
  templateUrl: './fichas.component.html',
  styleUrls: ['./fichas.component.css']
})
export class FichasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/fichas/fichas.component.ts